import { Component, Prop, Vue } from 'vue-property-decorator'

/**
 * Spacing styles mixin
 */
@Component
export default class extends Vue {

  @Prop({ type: [String, Number] })
  margin?: string | number

  @Prop({ type: [String, Number] })
  marginBottom?: string | number
  
  @Prop({ type: [String, Number] })
  marginLeft?: string | number
  
  @Prop({ type: [String, Number] })
  marginRight?: string | number

  @Prop({ type: [String, Number] })
  marginTop?: string | number

  @Prop({ type: [String, Number] })
  padding?: string | number

  @Prop({ type: [String, Number] })
  paddingBottom?: string | number

  @Prop({ type: [String, Number] })
  paddingLeft?: string | number

  @Prop({ type: [String, Number] })
  paddingRight?: string | number

  @Prop({ type: [String, Number] })
  paddingTop?: string | number

  get computedSpacingStyles () {
    const {
      margin,
      marginBottom,
      marginLeft,
      marginRight,
      marginTop,
      padding,
      paddingBottom,
      paddingLeft,
      paddingRight,
      paddingTop,
    } = this
    return {
      margin,
      marginBottom,
      marginLeft,
      marginRight,
      marginTop,
      padding,
      paddingBottom,
      paddingLeft,
      paddingRight,
      paddingTop,
    }
  }
}
